import { useEffect, useState } from "react";
import { StatusCatalog } from "@interfaces/response";
import { RootState } from "@store/store";
import { useSelector } from "react-redux";
import { STATUS_BURO_BLOQUEADO } from "@helpers/constantes";
import { getConfigName, getIncomeBranchStatusToDiscard } from "@helpers/funciones";

/**
 * El backend puede mandar `url` sin la diagonal inicial (`v2/producto/...`). React Router la toma
 * como ruta relativa y la encima sobre la actual, así que se normaliza a absoluta.
 */
const withAbsoluteUrl = (item: StatusCatalog | undefined | null): StatusCatalog | null => {
  if (!item) return null;
  if (!item.url || item.url.startsWith("/")) return item;
  return { ...item, url: `/${item.url}` };
};

const useLoanStatus = (status: string) => {
  const [currentStatus, setCurrentStatus] = useState<StatusCatalog | null>(null);
  const [nextStatus, setNextStatus] = useState<StatusCatalog | null>(null);
  const [previousStatus, setPreviousStatus] = useState<StatusCatalog | null>(null);

  const statusConfig = useSelector((state: RootState) => state.app.status_config);
  const incomeOption = useSelector((state: RootState) => state.register.income_declaration_option);

  useEffect(() => {
    if (status === "INIT") {
      setPreviousStatus(null);
      setNextStatus(withAbsoluteUrl(statusConfig[0]));
      setCurrentStatus(null);
    } else {
      // Además de buró bloqueado, la vía de ingresos que no se eligió en `DecisionIngreso` (si la empresa
      // la tiene configurada en `decisionIngresoConfig`).
      const status_to_discard = [
        STATUS_BURO_BLOQUEADO,
        ...getIncomeBranchStatusToDiscard(statusConfig, getConfigName(window.location.href), incomeOption),
      ];
      const status_filteres = statusConfig.filter((item) => !status_to_discard.includes(item.code));
      const currentIndex = status_filteres.findIndex((item) => item.code === status);

      if (currentIndex !== -1) {
        const previousIndex = currentIndex - 1;
        const nextIndex = currentIndex + 1;

        if (previousIndex !== -1) {
          setPreviousStatus(withAbsoluteUrl(status_filteres[previousIndex]));
        }
        if (nextIndex !== status_filteres.length) {
          setNextStatus(withAbsoluteUrl(status_filteres[nextIndex]));
        }
        setCurrentStatus(withAbsoluteUrl(status_filteres[currentIndex]));
      } else {
        setCurrentStatus(null);
        setNextStatus(null);
        setPreviousStatus(null);
      }
    }
  }, [status, statusConfig, incomeOption]);

  return {
    currentStatus,
    nextStatus,
    previousStatus,
  };
};

export default useLoanStatus;
